module.exports = __webpack_public_path__ + "static/media/icon-contact-active.b5aad905.svg";